import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";

var Theme = /*#__PURE__*/function () {
  function Theme(derivative) {
    _classCallCheck(this, Theme);

    this.derivative = void 0;
    this.derivative = derivative;
  }

  _createClass(Theme, [{
    key: "getDerivativeToken",
    value: function getDerivativeToken(token) {
      return this.derivative(token);
    }
  }]);

  return Theme;
}();

export { Theme as default };